import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Landing from "./Landing";

export default function HomeRedirect() {
  const navigate   = useNavigate();
  const hasToken   = !!localStorage.getItem("token");   // clave real

  useEffect(() => {
    if (hasToken) navigate("/app/", { replace: true });
  }, [hasToken, navigate]);

  // Si hay token devuelvo null (ya redirigí).  Si no, muestro la landing.
  return hasToken ? null : <Landing />;
}
